import PageHeader from "src/components/PageHeader";

export default function Coupons() {
  return (
    <PageHeader
      title="کوپن‌های تخفیف"
    />
  )
}
